import React, { createContext, useContext, useState, useEffect } from 'react';
import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const CMSContext = createContext(null);

export const CMSProvider = ({ children }) => {
  const [cms, setCms] = useState(null);

  useEffect(() => {
    axios.get(`${BACKEND_URL}/api/cms/homepage`)
      .then(({ data }) => setCms(data))
      .catch(() => {});
  }, []);

  return <CMSContext.Provider value={cms}>{children}</CMSContext.Provider>;
};

export const useCMS = () => useContext(CMSContext);
